import React from 'react';
import { useLocation } from 'react-router-dom';
import { CUSTOMER_SUPPORT } from '../data/customerPolicies';
import { DRIVER_SUPPORT } from '../data/driverAppSupport';
import '../styles/FloatingContact.css';

const FloatingContact = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const phoneNumber = CUSTOMER_SUPPORT.phoneTel;
  const whatsappNumber = DRIVER_SUPPORT.whatsappNumber;
  const whatsappMessage = 'Hello! I am interested in booking a taxi with Easy Drop Taxi.';

  return (
    <div
      className={`floating-contact-container${isHome ? ' floating-contact-container--home' : ''}`}
    >
      <a
        href={phoneNumber}
        className="floating-btn call-btn"
        aria-label="Call EasyDropTaxi"
      >
        <i className="fas fa-phone" aria-hidden="true"></i>
      </a>

      <a
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Chat with EasyDropTaxi on WhatsApp"
      >
        <i className="fab fa-whatsapp" aria-hidden="true"></i>
      </a>
    </div>
  );
};

export default FloatingContact;
